import maleIcon from "apps/QuoterApp/assets/images/Male Icon.png";
import femaleIcon from "apps/QuoterApp/assets/images/Female Icon.png";

export const MALE = "1";
export const FEMALE = "2";

export const GENDER_CHOICES = {
    [MALE]: "Male",
    [FEMALE]: "Female",
};

export const GENDER_ICONS = {
    [MALE]: maleIcon,
    [FEMALE]: femaleIcon,
};

export const GENDER_VALUES = Object.keys(GENDER_CHOICES);
